module.exports = __webpack_public_path__ + "img/fond-home-ldb.c019a284.jpg";